<template>
    <div>
        <!-- Prazos -->
        <div class="modal fade" id="prazosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="mostrar">
                    <div class="modal-header">
                        <h5 class="modal-title">Prazos</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div v-if="!prazos">
                            <div class="spinner-border mr-2" role="status" v-if="$store.state.loading">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>

                        <div v-else-if="prazos && prazos.status == 'success'">

                            <table class="table mt-3 mb-0">
                                <tbody>
                                    <tr v-for="(exames, prazo, chave) in lista_prazos" :key="chave">
                                        <td width="1%">{{ $util.getFormatDate(prazo) }}</td>
                                        <td width="1%"><span class="badge badge-secondary mr-1">{{ exames.length }}</span></td>
                                        <td>
                                            <span class="badge badge-pill mr-1" 
                                                :class="( exame.terc == 'S' ) ? 'badge-info' : 'badge-primary'"
                                                :title="( exame.nome ) + ( exame.terc == 'S' 
                                                    ? ' / Terceirizado' + ( exame.terc_sigla ? ' (' + exame.terc_sigla + ')' : '' )
                                                    : '' 
                                                )"
                                                v-for="(exame, iex) in exames" :key="iex">
                                                {{ exame.sigla }}

                                                <span class="ml-1" v-if="exame.prazo && exame.prazo.slice(11,16) && ( exame.prazo.slice(11,16) != '00:00' )">
                                                    {{ exame.prazo.slice(11,16) }}
                                                </span>

                                                <span class="ml-1" v-if="exame.fl_urgente">
                                                    <i class="fa-solid fa-circle-exclamation text-danger ml-1" title="Urgente"></i>
                                                </span>

                                                <span class="ml-1" v-if="exame.terc == 'S'">
                                                    <i class="fa-solid fa-location-pin"></i>
                                                </span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <div v-else class="alert alert-danger">
                            {{ prazos }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() { 
        return { 
            mostrar: false, 
        }
    },

    props: [
        'prazos',
    ],

    computed: { 
        lista_prazos: function () { 
            if ( !this.prazos ) { 
                return null;
            }

            return _.groupBy(
                _.orderBy(
                    this.prazos.lista, 
                    item => { 
                        return item.prazo ? item.prazo.slice(0,10) : '?';
                    }
                ),
                (item) => { 
                    return item.prazo ? item.prazo.slice(0,10) : '?';
                }
            );
        },
    },

    methods: { 
        fechar_modal() { 
            $('#prazosModal').modal('hide');
        },

        abrir() { 
            this.mostrar = true;
            $('#prazosModal').modal('show');
        }
    }
}
</script>
